
export const CONTROL_SHARING_TOGGLE = 'CONTROL_SHARING_TOGGLE';
export const EVENT_DATA_SERVICE = 'EVENT_DATA_SERVICE';

export const ALLOWED_USER_ID = 'ALLOWED_USER_ID';

export const SET_SELF_CONTROL = 'SET_SELF_CONTROL';

export const SET_CONTROLLER_ID = 'SET_CONTROLLER_ID';
export const SET_AUTOSTART_SHARING = 'SET_AUTOSTART_SHARING';
export const SET_VIRTUAL_SCREEN_ID = 'SET_VIRTUAL_SCREEN_ID';

export const ADD_WAITING_QUEUE = 'ADD_WAITING_QUEUE';
export const REMOVE_WAITING_QUEUE = 'REMOVE_WAITING_QUEUE';
export const SET_STATUS_CONTROL = 'SET_STATUS_CONTROL';

export const SET_ADMIN_STATE_CONTROL = 'SET_ADMIN_STATE_CONTROL';
